export default __webpack_public_path__ + "static/media/pic2.9a3ff6c8.png";